"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const Routes_1 = require("./Routes");
const react_2 = require("@osmosys/react");
// interface IProps {}
exports.AdminHome = () => {
    return (react_1.default.createElement(reusables_1.OsmosysResourcePage, { getNav: () => {
            return [
                {
                    id: 'search',
                    name: 'Search',
                    to: '/admin/search',
                },
                {
                    id: 'activityLog',
                    name: 'Activity log',
                    to: '/admin/activity',
                },
                {
                    id: 'settings',
                    name: 'Settings',
                    to: '/admin/settings',
                },
                {
                    id: 'users',
                    name: 'Users',
                    to: '/admin/users',
                },
                {
                    id: 'workspaceMemberships',
                    name: 'Memberships',
                    to: '/admin/memberships',
                },
                {
                    id: 'workspaces',
                    name: 'Workspaces',
                    to: '/admin/workspaces',
                },
            ];
        }, paths: {
            item: 'appSettings',
        }, headerColor: "danger", getTitle: () => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "appAdminsOnly", iconStyle: "regular", className: "mr-2" }),
            "Osmosys Admin")), getSubTitle: () => `${window.location.host}`, query: graphql_1.appSettings },
        react_1.default.createElement(react_2.OsmosysDiv, { osysName: "AdminHome.Inner", padding: true, flexRowFilled: true },
            react_1.default.createElement(Routes_1.Routes, null))));
};
exports.default = exports.AdminHome;
//# sourceMappingURL=index.js.map